/**
 * <s-card-swipe> — keeps the position dots of a swipeable product card photo strip in sync.
 * The strip itself is plain CSS scroll-snap, so it works without this script.
 */
class SCardSwipe extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-card-swipe-track]');
    this.dots = [...this.querySelectorAll('[data-card-swipe-dot]')];
    if (!this.track || this.dots.length < 2) return;
    this.onScroll = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const index = Math.round(Math.abs(this.track.scrollLeft) / (this.track.clientWidth || 1));
        this.dots.forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
      });
    };
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('s-card-swipe')) customElements.define('s-card-swipe', SCardSwipe);
